import { Link } from 'react-router-dom';

interface MidPageCTAProps {
  headline?: string;
  subtext?: string;
}

export default function MidPageCTA({
  headline = 'Schedule Your Free Estimate Before Spots Fill Up',
  subtext = 'Limited Spring 2026 availability — Parkside Pavers is scheduling 2–3 weeks out.',
}: MidPageCTAProps) {
  return (
    <section className="py-10 bg-parkside-dark border-y border-white/8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-parkside-amber/20 rounded-xl flex-shrink-0">
              <i className="ri-time-fill text-parkside-amber text-lg" />
            </div>
            <div>
              <p className="text-white font-bold text-base leading-tight">{headline}</p>
              <p className="text-white/55 text-sm mt-0.5">{subtext}</p>
            </div>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <a
              href="tel:813-404-6313"
              className="flex items-center gap-2 border border-white/25 text-white font-semibold px-5 py-2.5 rounded-xl hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              <span className="w-4 h-4 inline-flex items-center justify-center">
                <i className="ri-phone-fill" />
              </span>
              (813) 404-6313
            </a>
            <Link
              to="/contact"
              className="bg-parkside-amber text-white font-bold px-6 py-2.5 rounded-xl hover:bg-parkside-amber/90 transition-colors whitespace-nowrap cursor-pointer text-sm flex items-center gap-1.5"
            >
              Get a Free Estimate
              <span className="w-4 h-4 inline-flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
